import { Role } from 'lib/generated/graphql';
import { FunctionComponent } from 'react';
import Apply from './components/Apply';

interface ApplyAsFounderProps {}

const ApplyAsFounder: FunctionComponent<ApplyAsFounderProps> = () => {
  return <Apply role={Role.Customer} />;
};

export default ApplyAsFounder;
